import { Box, Card, Typography, IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import React, { useState } from 'react';

const OtpSection = ({ bookingDetailsdata }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        if (bookingDetailsdata?.startOTP) {
            navigator.clipboard.writeText(bookingDetailsdata.startOTP);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
        }
    };

    return (
        <Card sx={{ mb: '2%' }}>
            <Box sx={{px: '2%', borderBottom: '1px solid #E0E0E0' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: '1%' }}>
                    <Typography sx={{ fontWeight: '600', fontSize: '0.85rem' }}>Otp Detail's</Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', p: 1, justifyContent: 'center', gap: 2 }}>
                <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#3e3e3e', borderRadius: '1rem', bgcolor: '#e3e3e3', p: '1% 5%' }}>
                    Start Otp
                </Typography>
                <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#3e3e3e' }}>:</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#382cd5', borderRadius: '1rem', bgcolor: '#f0f8ff', p: '1% 5%' }}>
                        {bookingDetailsdata?.startOTP}
                    </Typography>
                    <Tooltip title={copied ? "Copied!" : "Copy OTP"}>
                        <IconButton size="small" onClick={handleCopy}>
                            <ContentCopyIcon fontSize="x-small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>
        </Card>
    );
};

export default OtpSection;